import {
  resolveSubscriptionCheckoutLookupKey,
  type SubscriptionCheckoutLookupKey,
  type SubscriptionPlanType,
} from '@/constants/subscriptions'

export const resolveCurrentSubscriptionCheckoutLookupKey = (
  planType: SubscriptionPlanType | null | undefined,
  interval: 'monthly' | 'annual' = 'monthly',
): SubscriptionCheckoutLookupKey | undefined => {
  if (!planType) return undefined
  return resolveSubscriptionCheckoutLookupKey(planType, interval)
}
